import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import type { VideoStatus } from "../../models/video.models";

@Component({
  selector: "app-video-status",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./video-status.component.html",
  styleUrl: "./video-status.component.scss",
})
export class VideoStatusComponent {
  @Input() status: VideoStatus = "waiting";
  @Output() cancel = new EventEmitter<void>();
}
